// extracted by mini-css-extract-plugin
export default {"shell":"CollateFrame_shell__1kbue","main":"CollateFrame_main__DS6hi","content":"CollateFrame_content__eattJ","pagePad":"CollateFrame_pagePad__ep14G"};